// extracted by mini-css-extract-plugin
export default {"heading":"heading_heading__hzOii","h1":"heading_h1__ra1R0","h2":"heading_h2__GpfzT","h3":"heading_h3__0QSp3","h4":"heading_h4__Tuihw","h5":"heading_h5__IYsPg"};